<script setup>
import { computed } from "vue";
import { ArrowLeftIcon } from "@heroicons/vue/20/solid";
import { useI18n } from "vue-i18n";

const { t: __ } = useI18n();

const props = defineProps({
    disabled: {
        type: Boolean,
        default: false,
    },
    processing: {
        type: Boolean,
        default: false,
    },
    showIcon: {
        type: Boolean,
        default: true,
    },
    label: {
        type: String,
    },
    icon: {
        default: undefined,
    },
});

const _label = computed(() => {
    if (typeof props.label === "function") {
        return props.label();
    }

    if (props.label === undefined) {
        return __("Précédent");
    }

    return props.label;
});
</script>

<template>
    <button
        type="button"
        :class="['transition inline-flex items-center gap-x-1.5 rounded-md py-2 px-4 text-sm font-semibold text-gray-700 dark:text-gray-400',
            disabled
                ? 'opacity-50 cursor-default'
                : 'cursor-pointer group hover:text-gray-900 dark:hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900 dark:focus-visible:outline-gray-100',
        ]"
        :disabled="disabled">
        <div :class="[processing ? 'invisible' : '', 'inline-flex items-center gap-x-1.5']">
            <Component
                v-if="showIcon"
                :is="icon !== undefined ? icon : ArrowLeftIcon"
                class="-ml-0.5 transform w-5 h-5 transition-transform group-hover:-translate-x-0.5"
                aria-hidden="true" />
            {{ _label }}
        </div>
        <div v-if="processing" class="absolute inset-0 flex justify-center items-center">
            <svg class="w-4 h-4 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
        </div>
    </button>
</template>
